import Radio, { RadioProps } from "@mui/material/Radio"

type L2RRadioButtonProps = {
    className?: string
    color?: "primary" | "default"
} & Omit<RadioProps, "color">

export const L2RRadioButton = (props: L2RRadioButtonProps) => {

    const {
        className,
        color = "primary",
        ...radioButtonProps
    } = props

    const radioButtonColor = color === "primary" ? "primary" : "common/black_states"

    return <Radio
        className={className}
        color={radioButtonColor}
        {...radioButtonProps}
    />
}
